export default {
    SINGLE_SELECT: 'single',
    PERIOD_SELECT: 'period',
};
